import React from 'react';
import { Outlet } from 'react-router-dom';

import ScrollToTop from '@app/components/LocalCommon/ScrollToTop/ScrollToTop';
import Footer from '@app/components/UI/Footer/Footer';
import Header from '@app/components/UI/Header/Header';
import '@app/scss/style.scss';

interface PageProps {
	withScrollTop?: boolean;
}

const LayoutCut: React.FC<PageProps> = ({ withScrollTop = true }) => {
	return (
		<div className="app-container">
			<Header />
			<div className="app-container-content">
				<Outlet />
			</div>
			<Footer />
			{withScrollTop && <ScrollToTop />}
		</div>
	);
};

export default LayoutCut;
